import React__default from 'react';
import PropTypes from 'prop-types';

function TextLink(_ref) {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement("span", props, children);
}
TextLink.propTypes = {
  /**
   * Any valid React node
   */
  children: PropTypes.string.isRequired,
  /**
   * Additional className
   */
  className: PropTypes.string
};

export { TextLink as default };
